define('formkit/view/block/design.section.menu.view',['require','exports','module','underscore','../form/section/section.composite.view','../../behavior/new.section.behavior','../../behavior/template.object.reorder.drag.drop.behavior'],function(require, exports, module) {
  var _                                     = require('underscore');
  var SectionCompositeView                  = require('../form/section/section.composite.view');
  var NewSectionBehavior                    = require('../../behavior/new.section.behavior');
  var TemplateObjectReorderDragDropBehavior = require('../../behavior/template.object.reorder.drag.drop.behavior');


  var DesignSectionCompositeView = SectionCompositeView.extend({

    options: _.extend({}, SectionCompositeView.prototype.options, {
      designable: true,
      readonly: true
    }),

    behaviors: _.extend({}, SectionCompositeView.prototype.behaviors, {
      NewSectionBehavior: {
        events: 'addSectionButton:press',
        insertNewSectionByDefault: true,
        behaviorClass: NewSectionBehavior
      },
      DragDrop: {
        behaviorClass: TemplateObjectReorderDragDropBehavior
      }
    }),

    initialize: function() {
      SectionCompositeView.prototype.initialize.apply(this, arguments);

      if (this.form) {
        this.collection = this.form.getTemplateModel().get('children')
      }
    }
  });

  module.exports = DesignSectionCompositeView;
});

